import React from 'react'
import { FiLayers } from 'react-icons/fi'
import LangSelector from '../LangSelector'
import { Button, SectionHeader } from '../../ui/UiComponents'
import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../../context/AuthContext'
import { useSelector } from 'react-redux'

const NavBar = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { loadingAuth } = useAuth();
  const userProfile = useSelector((state) => state.root.userProfile);

  return (
    <nav className="bg-white shadow-sm">
      <div className="container mx-auto px-4 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Link to="/">
              <SectionHeader
                title="Stocks Trading Checklist"
                titleClass="md:text-2xl text-base font-bold"
                titleType="h1"
                icon={FiLayers}
                iconSize={4}
              />
            </Link>
          </div>
          <div className="flex items-center gap-2">
            <div className="relative">
              <LangSelector dropdownPosition="top-full" showTitle={false} />
            </div>
            {userProfile && !loadingAuth && (
              <Button
                variant="primary"
                size="xs"
                onClick={() => navigate("/my-profile")}
              >
                {t("pages.profile.title")}
              </Button>
            )}
            {!userProfile && !loadingAuth && (
              <Button
                variant="outlinePrimary"
                size="xs"
                onClick={() => navigate("/auth/signin")}
              >
                {t("pages.auth.signin.title")}
              </Button>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default NavBar
